module.exports = __webpack_public_path__ + "img/smartmatic-logo@2x.ec53e5b5.png";